import { Injectable, OnDestroy } from "@angular/core";
import { CoreLogService } from "./log.service";
import { CircularInjectionHelper } from "./circularInjectionHelper";
import { Observable, Subject, Subscription } from "rxjs";
import { ConnectionState } from "./YourAppServer/YourAppServerSoket.service";
import { ObjectObserverFactory } from "./objectObserverFactory";
import { ContentType, orderTypes, NotificationsState, WebShopMode } from "../shared/contentTypes";
import { WebshopSettingsDataModel2, WebshopSettingsDMKey, InHouseDataModel, LocationWebshopViewModel, OrdertypeLocationSettings } from "../shared/models";
import { IObjectObserver } from "./IObjectObserver";
import { CoreCOMService } from "./com.service";
import { StorageHive, LocalKeys } from "./valueStorage.service";
import * as moment from "moment";
import Utils from "../shared/utils";
import { environment } from "../../../environments/environment";
import { Router } from "@angular/router";
import { WarningdialogComponent, ReconnectDialogComponent, AvailableServiceTimeComponent, NotificationsDialogComponent, NotificateViaSMSDialogComponent } from "../modalDialogs";
import { WebShopService } from "./webShop.service";
import { BottomSheetHelperService } from "./bottomSheetHelper.service";
import { UserHelperService } from "./userHelper.service";
import { MatBottomSheetRef } from "@angular/material";
import { Customer, IInHouseOrderService, ITableQRCode, IUiData, POSTable, req_ChangeBasket, req_ChangePaymentSelect, req_Order, req_ServiceCall, res_AbortPaymentSelect, res_ChangeBasket, res_ChangePaymentSelect, res_Order, res_ServiceCall, res_StartPaymentSelect, Seats, SetTableDone, Table, TableData, TableInfo, YASTable, _renameFull_POSTable, _renameFull_YASTable, res_GetStatus, req_UpdateCustomer, res_UpdateCustomer, TableChangedType, MessageType, POSTable_ItemStatus, GetPlaceStatus, req_ChangeGroupBasket, res_ChangeGroupBasket, res_MoveToGroupBasket, POSTable_Item, NotificationTyp, ChangeGroupBasketChangeType, ChangeGroupBasketStatus, BasketItem } from "./IInHouseOrderService";
import { ApiResponseData } from "./YourAppServer/YourAppServerApi.service";
import { RouterHelperService } from "./routerHelper.service";
import { LocationService } from "../components/location/location.service";
import { CoreLanguageService } from "./language.service";

//#region Hub Models

/** Models */

/** InHouseOrder Server Events */
const EVENT_TABLE_CHANGED = "TableChanged";

const EVENT_PAYMENT_SELECT_ABORTED = "PaymentSelectAborted";

const EVENT_NOTIFICATION = "Notification";

const EVENT_SERVER_IS_DISCONNECTING = "ServerIsDisconnecting";

/* InHouseOrder Server Function Calls (siehe YourAPPServerClient.Models.YASC ) */

const CALL_GET_PLACE = "GetPlace";
class req_GetPlace {
  /** tisch nummer */
  table_no: string;
  /** gruppen name */
  group_name: string;
  /** gruppen namen die als vorschläge nicht verwenet wurden
   *  und freigegeben werden sollen */
  release_group_names: string[];
  /** gruppen code */
  group_code: string;
  /** nickname */
  nickname: string;
  /** optional, sonst "" */
  user_token: string | null;
  /** optional, sonst 0 */
  place_no: number | null;
};

class res_GetPlace {
  /** ob ein Platz erhalten wurde */
  status: GetPlaceStatus;
  /** Tichnummer */
  table_no: string;
  /** Gruppenname */
  group_name: string;
  /** Gruppencode */
  group_code: string;
  /** ggf. neuer UserToken (wenn status=Okay) */
  user_token: string;
  /** ggf. neuer Platz (wenn status=Okay) */
  place_no: number;
  /** Anzahl an Gästen am Tisch / in der Gruppe */
  customer_count: number;
  /** Unbezahlte Artikel am Tisch */
  open_amount: number;
  /** Offener Betrag am Tisch in Cents */
  open_price: number;
};

const CALL_GET_TABLE = "GetTable";
/** Status ob GetTable Funktioniert hat */
enum GetTableStatus {
  /** Abruf des Tisches war erfolgreich */
  Okay = 0,
  /** Abrufen des Tisches war nicht möglich */
  Fail = 1,
  /** Fehler beim verarbeiten */
  Error = -1,
}
class res_GetTable {
  /** Status ob der Abruf vom Tisch erfolgrich war */
  status: GetTableStatus;
  /** POS Tisch Daten */
  pos_table: POSTable;
  /** YourAppServer Tisch Daten */
  yas_table: YASTable;
};

const CALL_GET_STATUS = "GetStatus";

const CALL_RECOMMEND_GROUPNAMES = "RecommendGroupNames";
/** Returnwert für Funktion RecommendGroupNames */
class res_RecommendGroupNames {
  /** Vorgeschlagene Gruppenbezeichnungen */
  group_names: string[];
};

const CALL_RELEASE_GROUPNAMES = "ReleaseGroupNames";
/** Parameter für Funktion ReleaseGroupNames */
class req_ReleaseGroupNames {
  /** Freizugebende Gruppenbezeichnungen */
  group_names: string[];
};

/** Returnwert für Funktion ReleaseGroupNames */
class res_ReleaseGroupNames {
  /** Freigabe der Namen war erfolgreich */
  success: boolean;
};

const CALL_UPDATE_CUSTOMER = "UpdateCustomer";

const CALL_CHANGE_BASKET = "ChangeBasket";

const CALL_MOVE_TO_GROUP_BASKET = "MoveToGroupBasket";

const CALL_CHANGE_GROUP_BASKET = "ChangeGroupBasket";

const CALL_GET_VAPID_PUBLIC_KEY = "GetVapidPublicKey";
/** Returnwert für Funktion GetVapidPublicKey */
class res_VapidPublicKey {
  /** VapidPublicKey */
  key: string;
}

const CALL_REGISTER_NOTIFICATION = "RegisterNotification";
/** Art der Benachrichtigung */
enum RegisterNotificationType {
  /** Web Push */
  WebPush = 0,
  /** SMS */
  SMS = 1,
  /** FCM */
  FCM = 2,
}

/** Parameter für Funktion RegisterNotification */
class req_RegisterNotification {
  /** Art der Bestellung */
  type: RegisterNotificationType;

  /** Daten zur regestrierung, ist vom Typ Abhängig (ggf. als JSON) */
  data: string

  /** Sprache in der der User sich Registriert hat und die Notification gesendet werden soll */
  language: string
}
/** Status der Regestrierung */
enum RegisterNotificationStatus {
  /** Erfolgreiche Regestrierung */
  Okay = 0,
  /** Fehlgeschlagen */
  Error = -1,
}
/** Returnwert für Funktion RegisterNotification */
class res_RegisterNotification {
  /** Status, ob die Regestrierung erfolgreich war */
  status: RegisterNotificationStatus;
}

const CALL_GET_NOTIFICATION_INFO = "GetNotificationInfo";
/** Returnwert für Funktion GetNotificationInfo */
class res_GetNotificationInfo {
  /** Information zur Geschlossenen Notification */
  info: string;
}

const CALL_ORDER = "Order";

const CALL_ITEMS_NOTICED = "ItemsNoticed";
/** Parameter für Funktion ItemsNoticed */
class req_ItemsNoticed {
  /** artikel die als bemerkt mariert werden sollen */
  items: number[];
};

/** Status der verarbeitung für ItemsNoticed */
enum ItemsNoticed_Status {
  /** Änderung war erfolgreich */
  Okay = 0,
  /** Fehler beim verarbeiten */
  Error = -1,
}
/** Parameter für Funktion ItemsNoticed */
class res_ItemsNoticed {
  /** Status der verarbeitung */
  status: ItemsNoticed_Status;
}

const CALL_START_PAYMENT_SELECT = "StartPaymentSelect";

const CALL_CHANGE_PAYMENT_SELECT = "ChangePaymentSelect";

const CALL_ABORT_PAYMENT_SELECT = "AbortPaymentSelect";

const CALL_SERVICE_CALL = "ServiceCall";

//#endregion

// sonstige typen

/** Representation von Tisch informationen zum QRCode */
class TableQRCode implements ITableQRCode {
  qrCode: string = "";
  location: number = NaN;
  tableName: string = "";
  tableNr: string = "";
  mandatory_Payment: boolean = false;
}

/** Daten welche im Cache zwischen gespeichert werden können */
class CachebleData {
  /** Tisch Code */
  tableData: TableQRCode = new TableQRCode();
  /** Durch POS ausgegeben Tischnummer */
  posTableNr: string = "";
  /** Gruppen Bezeichnung */
  groupName: string = "";
  /** Gruppen Code */
  groupCode: string = "";
  /** Gruppen Erstellen */
  groupCreator: string = "";
  /** User Nickname */
  userNickname: string = "";
  /** Platznummer */
  placeNo: number = NaN;
  /** User Token */
  userToken: string = "";
  /** in den Speicher abgelegt Datum */
  cachedAt_YMD: number = -1;
  /** in den Speicher abgelegt Uhrzeit */
  cachedAt_HMS: number = -1;
  // todo eventuel created_at um zu prüfen und nach mehr als 24 stunden es einfach zu löschen
}

/** Anfrage auf prüfung des Gruppencodes, siehe GetGroupcodeInfo */
class Groupcode {
  /** zuprüfender code */
  code: string;
}

/** Antwort auf den aufruf von GetGroupcodeInfo */
class GroupcodeInfo implements ApiResponseData {
  /** gültigkeit des Gruppencodes */
  valide: boolean;
  /** Standort */
  location: number;
  /** Tischnummer */
  table_no: string;
  /** Gruppenname */
  group_name: string;
  /** Gruppen erzeuger */
  group_creator: string;
  /** Gruppe bereits voll */
  is_full: boolean;

  public DeserializeType(): void {
    // has no complex type
  }
}

/** gruppen information, wird aus einem Gruppencode ermittelt */
type GroupInfo = {
  /** gruppencode informationen */
  group_code_info: GroupcodeInfo,
  /** tischCode zum GruppenCode */
  tableQRCode: ITableQRCode
}

/** enhält informationen für eine neuanlage einer gruppe */
export class TableGroupInfo implements ApiResponseData {
  /** tisch verfügt über offene gruppen */
  table_has_groups: boolean;
  /** limmit ist erreicht, neue Gruppe kann an den tisch nicht angelegt werden */
  group_limit_reached: boolean;
  /** reservierte namen vorschläge für neue gruppe */
  group_names: string[];

  public DeserializeType(): void {
    // has no complex type
  }
}

class TableGroupRequest {
  location: number;
  table_no: string;
}

/** enhält informationen für eine neuanlage einer gruppe */
class ReleaseGroupNames implements ApiResponseData {
  /** freigabe war erfolgreich */
  success: boolean;

  public DeserializeType(): void {
    // has no complex type
  }
}

class ReleaseGroupNamesRequest {
  location: number;
  names: string[];
}

@Injectable({
  providedIn: "root"
})
export class InHouseOrderService implements IInHouseOrderService, OnDestroy {

  //#region Default Connection Events

  private _onSocketOpend: Subscription;
  private OnSocketOpend(): void {
    const me = this;
    me.autoreconnect = true;
    //me._opend.next();
  }
  //private _opend: Subject<void> = new Subject();
  ///** Verbindung wurde geöffnet */
  //private get ObserveOpend(): Observable<void> {
  //  return this._opend;
  //}

  private _onSocketReconnecting: Subscription;
  private OnSocketReconnecting(): void {
    const me = this;
    me.openReconnectDialog();
    //me._reconnecting.next();
  }
  //private _reconnecting: Subject<void> = new Subject();
  ///** Wird aufgerufen wenn nach einem Fehler die Verbindung versucht wird wieder herzustellen. */
  //public get ObserveReconnecting(): Observable<void> {
  //  return this._reconnecting;
  //}

  private _onSocketReconnected: Subscription;
  private OnSocketReconnected(): void {
    const me = this;
    //me._reconnected.next();
    // wenn ein Tisch vorhanden war, so können informationen fehlen, deswegen ein erneuter abruf
    if (me._table) {
      me.GetTable(TableData.All).then((table) => {
        me.closeReconnectDialog();
        if (table) {
          // ALL da unbekannt ist ob sich etwas geändert hat
          // bzw. optional, hier könnte man auch mit dem ChangeCount gearbeitet werden um änderungen mitzubekommen
          me._onTableChanged.next(TableChangedType.All);
        } else {
          me._coreLogService.error("InHouseOrderService.OnSocketReconnected", "GetTable no table");
          // todo leave table
          console.log("todo leave table")
        }
      }).catch((error) => {
        me._coreLogService.error("InHouseOrderService.OnSocketReconnected", "GetTable status not Okay", error);
        // todo leave table
        console.log("todo leave table")
      })
    } else {
      me.closeReconnectDialog();
    }
  }
  //private _reconnected: Subject<void> = new Subject();
  ///** Wird aufgerufen wenn es erfolgreich wieder Verbunden wurde nach einem Timeout. */
  //public get ObserveReconnected(): Observable<void> {
  //  return this._reconnected;
  //}

  // TODO sollte zu einer zeit werden und auf 15 Sekunden eingestellt werden
  /** versuche für eine erneute verbindung */
  private _reconnectCount: number = 0;

  private _onSocketClosed: Subscription;
  private async OnSocketClosed(): Promise<void> {
    const me = this;
    if (me._suspendedConnection) {
      return; // is suspendet not closed
    }

    if (me._IsInReconnection) {
      me._coreLogService.info("InHouseOrderService.OnSocketClosed", "_IsInReconnection, skip reconnect");
      return; // is already in reconnection
    }

    if (me.autoreconnect && me._reconnectCount < 3) {
      if (me._reconnectCount++ == 0) {
        //me._reconnecting.next();
        me.openReconnectDialog();
      }

      me._suspendedConnection = me._currentData;
      me._IsInReconnection = true;
      const socket = me._objObsInjectHelper.yourAppServer.Socket;
      try {
        // versuche eine neue verbindung auszuhandeln
        try {
          await socket.Connect(socket.Connection.location);
        } catch (error) {
          me._coreLogService.error("InHouseOrderService.OnSocketClosed", "socket.Connect1.catch, wait and try again", error);
          await Utils.wait(2000); // versuche nach 2 Sekunden erneut, bei einem Ausfall ist die Internet Verbindung am Smartphone unzuverlässig
          await socket.Connect(socket.Connection.location);
        }
        me._reconnectCount = 0;
        me._suspendedConnection = null;

        let success_re_place = false;
        try {
          // versuche GetPlace alten Platz am Tisch zu erhalten, wenn möglich, alles okay
          const req: req_GetPlace = {
            table_no: me._currentData.posTableNr,
            group_name: me._currentData.groupName,
            group_code: me._currentData.groupCode,
            release_group_names: [],
            nickname: me._currentData.userNickname,
            place_no: me._currentData.placeNo,
            user_token: me._currentData.userToken
          };
          // erhalte alten Platz am Tisch
          const res = await me._GetPlace(req);
          success_re_place = res && res.status == GetPlaceStatus.Okay;
        } catch (error) {
          me._coreLogService.error("InHouseOrderService.OnSocketClosed", "_GetPlace.catch", error);
          // success_re_place bleibt false 
        }

        if (success_re_place) {
          //me._reconnected.next();
        } else {
          me._closed.next();
          me.leaveTable(true);
        }
        me.closeReconnectDialog();
      } catch (error) {
        // reconnect faild
        me._coreLogService.error("InHouseOrderService.OnSocketClosed", "socket.Connect.catch", error);
        me.CleanUp();
        me._closed.next();
        me.closeReconnectDialog();
        me.leaveTable(true);
      }
      me._IsInReconnection = false;
    } else {
      me.CleanUp();
      me._closed.next();
      if (me.autoreconnect) {// Connection Lost war nicht vorgesehen
        me.closeReconnectDialog();
        me.leaveTable(true);
      }
    }
  }

  private _closed: Subject<void> = new Subject();
  /** Verbindung wurde geschlossen */
  public get ObserveClosed(): Observable<void> {
    return this._closed;
  }

  //#endregion

  /** führt bei einer Trennung ein reconnect durch */
  private autoreconnect: boolean = true;

  /** momentan die Möglichkeit auf dem BezahlbestätigungsScreen die Warnung über geschlossenen tisch zu unterdrücken */
  public suppressNextTableClosedWarning: boolean = false;

  //#region Ui relevante Informationen für 

  private _uiDataChanged: Subject<IUiData> = new Subject();
  /** Wird aufgerufen wenn es erfolgreich wieder Verbunden wurde nach einem Timeout. */
  public get ObserveUiDataChanged(): Observable<IUiData> {
    return this._uiDataChanged;
  }

  /** cache der UI Daten, nutzung von _ChangeUiData() um es zu ändern */
  private _uiData: TableInfo = new TableInfo();
  /** Für Oberfläche (wie navigtion oder homescreen) relevenate daten */
  public get UiData(): IUiData {
    return this._uiData;
  }

  /** sollte aufgerufen werden im die Information zu aktualisieren */
  private _ChangeUiData(newData: TableInfo) {
    const me = this;
    if (me._uiData.table_no !== newData.table_no ||
      me._uiData.place_no !== newData.place_no ||
      me._uiData.group_name !== newData.group_name ||
      me._uiData.group_code !== newData.group_code ||
      me._uiData.user_nickname !== newData.user_nickname ||
      me._uiData.open_amount !== newData.open_amount ||
      me._uiData.open_price !== newData.open_price ||
      me._uiData.customer_count !== newData.customer_count) {
      me._uiData = newData;
      me._uiDataChanged.next(me.UiData);
    }
  }

  //#endregion

  /** Ermittelt den momentanen Connection Status */
  public get Status(): ConnectionState {
    return this._objObsInjectHelper.yourAppServer.Socket.Status;
  }

  /** Zwischenspeicher für einen Table */
  private _table: Table = null;

  /** Aktuell genutze Daten */
  private _currentData: CachebleData = new CachebleData();

  /** Aktueller Tisch Code */
  public get TableData(): ITableQRCode {
    return this._currentData.tableData;
  }

  /** Am POS intern zugeordnete Tisch Nummer */
  public get POSTableNr(): string {
    return this._currentData.posTableNr;
  }

  /** Aktuelle Gruppen Bezeichnung */
  public get GroupName(): string {
    return this._currentData.groupName;
  }

  /** Aktueller Gruppen Code */
  public get GroupCode(): string {
    return this._currentData.groupCode;
  }

  /** Ersteller der Gruppe */
  public get GroupCreator(): string {
    return this._currentData.groupCreator;
  }

  /** Aktueller User Nickname */
  public get UserNickname(): string {
    return this._currentData.userNickname;
  }

  /** Aktueller User Token */
  public get UserToken(): string {
    return this._currentData.userToken;
  }

  /** Aktuelle Platznummer */
  public get PlaceNo(): number {
    return this._currentData.placeNo;
  }

  //#region Beschreibung "Möglicher Ablauf"

  /** todo
   * Mainnav.component > inHouseOrderMode > true anzeige, (tisch icons in der nav bar) 
   * home.component >  InHauseServiceSelectorService ersetzrn durch InHouseOrderServcie derective inHouseTableButton.component.html (tisch ticke)
   * inHauseServiceSelector > landing page, wenn das setzen an den Tisch erfolgreich war
   * inhouseorderresult > im checkout und im intent einbauen
   */

  /**
   * Mögliche einsprünge
   * -kein
   * -payment
   * -scan tableQrCode
   * 
   * > wenn kein
   * funktion zum prüfen ob cache daten existieren
   *  wenn ja (und optional er sich noch im laden befindet) versuchen verbinden, prüfen ob ein POS zu hört und erneut an den zisch zurück zu setzen
   *    wenn erfolgreich kann der Tisch erneut angezeigt werden und gast kann weitermachen (siehe wenn scan)
   *    wenn es fehlschlägt verbindung trennen und cache löschen
   *  wenn nein ende
   * 
   * > wenn payment
   * funktion zum anzeigen vom ergebniss und in den payload sind daten um sich erneut zu verbinden. (es sollte auch info enthalten ob der tisch geschlossen wurde)
   * an hand vom ih status wird die InHouse funktionalität aufgerufen, was auf der result page für IH landet (mit nocoo url) 
   * wenn tisch geschloßen wird auch die Verbindung trennen, aus ImHaus weg nawigieren, Nocoo oder Startseite
   * 
   * > wenn scan (erfolgt aus dem in House)
   * Funktion um über den Code sich zu verbinden.
   * aus dem COde Tisch ermitteln mit Server verbinden und prüfen ob POS zuhört
   * wenn ja Platz am tisch erfragen
   *  wenn okay bekommt man platz am tisch und info, ob offne artkel bereitliegen
   *    es erfolgt eine bindung an OnNotification, OnTableChanged und ObserveOnPaymentSelectAborted
   *      entsprechen der events kann die oberfläche reagieren
   *    Artikel können nun in den warenkorb mit ChangeBasket hinzugefügt werden
   *    es kann danach ein Order bzw PayAndOrder aus geführt
   *      OrderAndPay siehe unter Order GetPaymentMethods
   *      Order man kann sein warenkorb damit ordern und bekommt ein Okay vom POS
   *        wegen der 'Mögliche einsprünge kein' und 'mögliche Erignisse app kehrt aus dem sleepmodus zurück' kann der wieder eine verbindung hergestelt werden
   *        extra, solange es nicht in sleep geht, kann es die anzahl der offenen Artikel aktualisieren.
   *        Wenn man zahlen möchte wählt man es aus und dabei wird StartPaymentSelect gestartet
   *          es wird der Tisch abgerufen mit allen Artikeln, Gästen und laufenden zahlungen
   *            interaktiv kann nun selektiert werden was man bezahlen möchte mit ChangePaymentSelect
   *              vor dem GetPaymentMethods muss api/SyncConnection aufgerufen werden um die Daten abzugleichen
   *                danach kann ih_data erzeugt und in die Payment Methoden übergeben werden, das Payment erfolgt wie gehabt.
   *                   
   *          wenn die zahlungs auswahl nicht im payment endet muss ein AbortPaymentSelect erfolgen
   *    es ist möglich nach dem Scan ein ServiceRuf zu starten, da dann ein Platz zugewiesen wurde
   *      bediener am POS können auch nachrichten zurück senden
   *  wenn fehlschlägt, WAS TUN? Neu scannen?
   * wenn nein meldung das ImHaus momentan nicht geht
   * 
   * mögliche Erignisse:
   * -app geht in den sleepmodus
   * -app kehrt aus dem sleepmodus zurück
   * 
   * > wenn app geht in den sleepmodus
   * Funktion zum trennen der verbindung und daten merken um nach dem aufwachen erneut sich zu verbinden
   * 
   * > wenn app kehrt aus dem sleepmodus zurück
   * prüfen ob vor dem Sleepmodus eine verbindung bestanden hat
   * wenn ja bei "Mögliche einsprünge kein" weitermachen
   * Wenn nein keine aktion 
   */

  //#endregion

  private _userRegisterd: Subscription;
  private _objObsInjectOnInit: Subscription;

  /** initialisierung und Bindung */
  constructor(private _coreLogService: CoreLogService,
    private _coreLanguageService: CoreLanguageService,
    private _coreCOMService: CoreCOMService,
    private _objObsInjectHelper: CircularInjectionHelper,
    private _webShopService: WebShopService,
    private _userHelperService: UserHelperService,
    private _router: Router,
    private _bottomSheetHelperService: BottomSheetHelperService,
    private _routerHelperService: RouterHelperService,
    private _locationService: LocationService) {
    const me = this;
    me._coreLogService.debug("InHouseOrderService", "constructor"); // todo remove in release (test das es nur einmal aufgerufen wird)

    me._userRegisterd = me._userHelperService.RegisterObserver.subscribe((registerd) => me.OnUserLogedIn(registerd));

    me._objObsInjectOnInit = me._objObsInjectHelper.ObserveOnInit.subscribe(() => {
      const socket = me._objObsInjectHelper.yourAppServer.Socket;
      me._onSocketOpend = socket.ObserveOpend.subscribe(() => me.OnSocketOpend());
      me._onSocketReconnecting = socket.ObserveReconnecting.subscribe(() => me.OnSocketReconnecting());
      me._onSocketReconnected = socket.ObserveReconnected.subscribe(() => me.OnSocketReconnected());
      me._onSocketClosed = socket.ObserveClosed.subscribe(() => me.OnSocketClosed());

      socket.On(EVENT_TABLE_CHANGED, (...args: any[]) => me.OnTableChanged(...args));
      socket.On(EVENT_PAYMENT_SELECT_ABORTED, (...args: any[]) => me.OnPaymentSelectAborted(...args));
      socket.On(EVENT_NOTIFICATION, (...args: any[]) => me.OnNotification(...args));
      socket.On(EVENT_SERVER_IS_DISCONNECTING, (...args: any[]) => me.OnServerIsDisconnecting(...args));
    })
  }

  /** Freigeben der Ressourcen und Unbinding */
  ngOnDestroy(): void {
    const me = this;
    me._coreLogService.debug("InHouseOrderService", "ngOnDestroy"); // todo remove in release (test das es maximal einmal aufgerufen wird)
    const socket = me._objObsInjectHelper.yourAppServer.Socket;

    socket.Off(EVENT_TABLE_CHANGED);
    socket.Off(EVENT_PAYMENT_SELECT_ABORTED);
    socket.Off(EVENT_NOTIFICATION);
    socket.Off(EVENT_SERVER_IS_DISCONNECTING);

    if (me._userRegisterd) {
      me._userRegisterd.unsubscribe();
    }

    if (me._objObsInjectOnInit) {
      me._objObsInjectOnInit.unsubscribe();
    }
    if (me._webshopSettingsChanged) {
      me._webshopSettingsChanged.unsubscribe();
    }

    if (me._onSocketOpend) {
      me._onSocketOpend.unsubscribe();
    }
    if (me._onSocketReconnecting) {
      me._onSocketReconnecting.unsubscribe();
    }
    if (me._onSocketReconnected) {
      me._onSocketReconnected.unsubscribe();
    }
    if (me._onSocketClosed) {
      me._onSocketClosed.unsubscribe();
    }

    me.closeReconnectDialog();
  }

  /** Hält referenz auf ein geöffneten Reconnect Dialog */
  private reconnectDialog: MatBottomSheetRef<any, any> = null;

  /** Öffnen eines Reconnect Dialogs (Achtung muss mit closeReconnectDialog geschloßen werden) */
  private openReconnectDialog() {
    const me = this;
    me.closeReconnectDialog();
    me.reconnectDialog = me._bottomSheetHelperService.open(ReconnectDialogComponent, {
      autoFocus: false,
      disableClose: true,
    });
  }

  /** Schließt ein geöffneten Reconnect Dialogs */
  private closeReconnectDialog() {
    const me = this;
    if (me.reconnectDialog) {
      me.reconnectDialog.dismiss();
    }
  }

  /** verläst tisch und beendet die offene verbindung */
  public async leaveTable(showConnectionLostDialog: boolean): Promise<void> {
    const me = this;
    if (me._webShopService.getServiceMode() === WebShopMode.OrderToTable) {
      try {
        me._webShopService.resetWebshopService();
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.leaveTable", "catch", error);
      }
      try {
        await me.CleanupCacheData();
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.leaveTable", "CleanupCacheData.catch", error);
      }
      if (showConnectionLostDialog) {
        me.OpenWarningLostConnection();
      }
      me._router.navigateByUrl("/"); // home
    } // else not at table
  }

  /** ermittelt ob es artikel im Gruppenwarenkorb gibt */
  public async HasGroupBasketItems(): Promise<boolean> {
    const me = this;
    let hasItems = false;
    try {
      if (me.GroupCode != "") {
        const table = await me.GetTable(null); // null damit kein unnötiger Abruf stattfindet
        hasItems = table.yasTable.group_basket_items.length > 0;
      }
    } catch (error) {
      me._coreLogService.error("InHouseOrderService.HasGroupBasketItems", "catch", error);
    }
    return hasItems;
  }

  /** Aktualisiert den User Nikname, wenn sie sein Login status ändert */
  private async OnUserLogedIn(loged_in: boolean): Promise<void> {
    const me = this;
    if (!Utils.IsNullOrEmpty(me.UiData.table_no) && !me.UiData.isGroup) {
      let userNickname = "";
      if (loged_in) {
        try {
          const userInfo = await me._userHelperService.GetUserData(false);
          if (userInfo)
            userNickname = userInfo.fname;
        } catch (error) {
          me._coreLogService.error("InHouseOrderService.OnUserLogedIn", "GetUserData.catch", error);
        }
      } // else keep name empty

      if (userNickname != me.UiData.user_nickname) {
        try {
          await me._SetTableCode(me.TableData, me.POSTableNr, me.GroupName, [], me.GroupCode, me.GroupCreator, userNickname, me.PlaceNo, me.UserToken);
        } catch (error) {
          me._coreLogService.error("InHouseOrderService.OnUserLogedIn", "_SetTableCode.catch", error);
        }
      }
    } // else not connected to a table (or connected to a group, there is name change not possible yet)
  }

  /** status, ob eine offene Verbinung pausiert wurde */
  private _suspendedConnection: CachebleData = null;

  /** pausiert die offene SignalR verbindung. Sollte aufgerufen werden wenn die Seite suspandet wird */
  public Pause(): void {
    const me = this;
    if (me.Status === ConnectionState.Connected) {
      me._suspendedConnection = me._currentData;
      me.Disconnect(false);
    }
  }

  /** reaktiviert die offene SignalR verbindung. Sollte aufgerufen werden wenn die Seite suspandet wird */
  public Resume(): void {
    const me = this;
    if (me._suspendedConnection) {
      me.Reconnect(me._suspendedConnection);
      me._suspendedConnection = null;
    }
  }

  //#region Alte Funktionalität

  /**********************Inhause*******************************/

  /* Sollte durch ein Intent ausgelöst werden, welcher Extern ausgelöst wird */
  public onExternIntent(url: string): Promise<void> {
    const me = this;
    let params = ""
    return new Promise(async (resolve, reject) => {
      try {
        if (me._coreCOMService.environment.client.isMobile) {
          url = url.substr(url.indexOf("://"));
          params = url.replace("://", "?");
        } else {
          params = url.substr(url.indexOf("?"));
        }
        const urlParams = new URLSearchParams(params);
        const type = urlParams.get("type");
        if (type === "QRcodescanner") {
          const qrcode = urlParams.get("QRcode");
          if (me._coreCOMService.environment.client.isMobile || me._coreCOMService.environment.client.isBrowserMobileSafari
            || me._coreCOMService.environment.client.isBrowserSafari) {
            me._coreCOMService.environment.splashscreen.hide();
            await me.tryOpenTableCode(qrcode);
          } else /* Browser, nicht Safari */ {
            // versuch als App zu starten (auf Android würde es fragen, ob es als APP ausgeführt werden sollte)
            try {
              const target = `${environment.IntentScheme}://type=QRcodescanner&QRcode=${qrcode}`;
              var inAppBrowser = window.open(target, "_self");
            } catch (error) {
              me._coreLogService.error("InHouseOrderService.onExternIntent", "window.open, open application", error);
              // redirect hat nicht funktioniert, ohne exception weitermachen
            } finally {
              me._coreCOMService.environment.splashscreen.hide();
              await me.tryOpenTableCode(qrcode);
            }
          }
        }
        resolve();
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.onExternIntent", "try catch", error);
        reject(error);
      }
    });
  }

  /** vesucht anhand des Tischcodes und der einstellung zu Tisch oder Gruppenbestellung weiterzuleiten */
  public async tryOpenTableCode(tablecode: string): Promise<void> {
    const me = this;

    try {
      const settings = await me._webShopService.getWebshopSettingsDataModel();
      const servicelocation = settings.customer_location_qrCode.find(c => c.tableQRCode.some(q => q.qrCode.toLowerCase() === tablecode.toLowerCase()));
      if (servicelocation) {
        const location = await me._locationService.GetWebshopLocationInfoViewModel(WebShopMode.OrderToTable, servicelocation.locationId);
        if (location && location.checkOpenTime()) {
          await me._webShopService.setServiceMode(WebShopMode.OrderToTable);
          // versuche den alten platz zu erhalten
          const hasPlaceFromCache = await me.TryUseCachedData(tablecode);
          if (hasPlaceFromCache) {
            // der Gast hat sein alten Platz bekommen
            me._router.navigate(["/inHauseServiceSelector"]);
          } else {
            const mandatory_Payment: boolean = (await me.GetTableQRCodeData(tablecode)).mandatory_Payment;
            if (settings.in_house_order && settings.in_house_order.grouporder && settings.in_house_order.grouporder.is_active) {
              if (mandatory_Payment) {
                me._routerHelperService.setRouteTargetDataByKey("tablecode", tablecode);
                me._router.navigate(["/inHouseUserNameRequest"]);
              } else {
                me._routerHelperService.setRouteTargetDataByKey("tablecode", tablecode);
                me._router.navigate(["/orderModeSelector"]);
              }
            } else {
              //! todo sollte hier nicht die nickname eingabe geöffnet werden? CDS muss beachtet werden
              const askUserName = true;
              if (askUserName && !settings.payment_inhouse_without_order) {
                me._routerHelperService.setRouteTargetDataByKey("tablecode", tablecode);
                me._router.navigate(["/inHouseUserNameRequest"]);
              } else {
                try {
                  await me._webShopService.submitTableCodeData(tablecode, "")
                } catch (error) {
                  me._coreLogService.error("InHouseOrderService.tryOpenTableCode", "_webShopService.submitTableCodeData(catch)", tablecode, error);
                }
              }
            }
          }
        } else {
          me.openAvaliableServiceTime(location, WebShopMode.OrderToTable)
        }
      } else {
        me.OpenWarningNoLocation();
      }
    } catch (error) {
      me._coreLogService.error("InHouseOrderService.tryOpenTableCode", "catch", tablecode, error);
    }
  }

  /** Versuchen den Gast an seinen vorherigen Platz zu setzen, falls der tischcode übereinstimmt, wenn es gelingt true, sonst false */
  private async TryUseCachedData(tablecode: string): Promise<boolean> {
    const me = this;
    const cashedData = await me.LoadCachedData();
    if (cashedData && cashedData.userToken.length > 0 && cashedData.tableData && cashedData.tableData.qrCode == tablecode) {
      if (await me.CheckCachedDataValide(cashedData)) {
        const res = await me.TryGetBackToStoredTableOrGroup();
        return res.success;
      }
    }
    return false;
  }

  /** Versucht den Gast erneut in seine vorherige Gruppe zu setzen */
  public async TryUseCachedDataForGroup(groupcode: string): Promise<boolean> {
    const me = this;
    const cashedData = await me.LoadCachedData();
    if (cashedData && cashedData.userToken.length > 0 && cashedData.groupCode == groupcode) {
      if (await me.CheckCachedDataValide(cashedData)) {
        const res = await me.TryGetBackToStoredTableOrGroup();
        return res.success;
      }
    }
    return false;
  }

  /** Navigieren zur Landingpage vom InHouseOrder
   * @param qrcode tischCode
   * @param nickname gewünschter Nickname
   */
  private openInHauseServiceSelector(qrcode: string, nickname: string): Promise<void> {
    const me = this;
    return new Promise<void>((resolve, reject) => {
      me._router.navigate(["/inHauseServiceSelector"]).then((res) => {
        if (res) {
          if (me.TableData.qrCode != qrcode) {
            me._webShopService.submitTableCodeData(qrcode, nickname).then(resolve).catch(reject);
          } else { // qrcode ist bereits hinterlegt, nur navigieren
            resolve();
          }
        } else {
          me._coreLogService.error("InHouseOrderService.onExternIntent", "router.navigate /inHauseServiceSelector fails");
          reject();
        }
      }).catch(reject);
    });
  }

  /** leitet auf die entsprechende LangingPage um */
  public async openInHauseLandingPage(): Promise<void> {
    const me = this;
    me._webShopService.onUserChange()
    if (Utils.IsNullOrEmpty(me.GroupCode)) {
      await me.openInHauseServiceSelector(me.TableData.qrCode, me.UserNickname);
    } else {
      // todo sollte es hier auch sie neu initialiiseren??
      me._router.navigate(["/groupOrderServiceSelector"]);
    }
  }

  /**********************End Of Inhause*******************************/

  //#endregion

  //#region notification

  /** Prüfung ob der Browser Notifications unterstützt.
   * Bei iOS muss unter "Settings/Safari/Advanced/Experemental/Notification" aktiviert werden.
   * Auch muss die Seite als Shortcut auf dem Homescreen hinterlegt werden.
   */
  public async canUseNotification(): Promise<boolean> {
    return typeof Notification !== "undefined";
  }

  /** Prüfung ob der Browser WebPush unterstützt. 
   * Bei iOS muss unter "Settings/Safari/Advanced/Experemental/Web Push" aktiviert werden.
   * Auch muss die Seite als Shortcut auf dem Homescreen hinterlegt werden.
   */
  public async canUseWebPush(): Promise<boolean> {
    return "PushManager" in window;
  }

  /** Erbittet über den Browser die Permission von User zur zustellung von Notificationen */
  public async getPermissionForPushNotification(): Promise<boolean> {
    const me = this;
    try {
      const permission = await Notification.requestPermission();
      return permission == "granted";
    } catch (error) {
      me._coreLogService.error("InHouseOrderService.getPermissionForPushNotification", "catch", error);
      return false;
    }
  }

  /** wird zur umvandlung des vapidPublicKey benötigt */
  private urlB64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/\-/g, '+')
      .replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  /** versucht die Notification zu regestrieren, anhand vom Typ, bei SMS ist die Nummer als Data notwendig, Push braucht keine Data */
  public async setNotification(type: "SMS" | "Push" | "FCM", data: string): Promise<boolean> {
    const me = this;
    if (type == "SMS") {
      if (data == null) {
        me._coreLogService.error("InHouseOrderService.setNotification", "SMS need number as data");
        return false;
      }
      const response = await me.RegisterNotification({
        type: RegisterNotificationType.SMS,
        data: data,
        language: me._coreLanguageService.getCurrentLanguage()
      });
      return response.status == RegisterNotificationStatus.Okay;
    } else if (type == "Push") {
      if (data != null) {
        me._coreLogService.error("InHouseOrderService.setNotification", "Push data not needed");
      }
      try {
        let canUse = await me.canUseWebPush();
        canUse = canUse && await me.canUseNotification();
        const vapidPublicKey = await me.GetVapidPublicKey();
        canUse = canUse && !Utils.IsNullOrEmpty(vapidPublicKey);

        if (canUse) {
          let hasPermission = await me.getPermissionForPushNotification();
          if (hasPermission) {
            const registration = await navigator.serviceWorker.getRegistration();
            let subscription = await registration.pushManager.getSubscription();
            if (subscription) {
              await subscription.unsubscribe(); // try clean up, no need for wait
            }
            // create new subscription
            subscription = await registration.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: me.urlB64ToUint8Array(vapidPublicKey)
            });
            const response = await me.RegisterNotification({
              type: RegisterNotificationType.WebPush,
              data: JSON.stringify(subscription),
              language: me._coreLanguageService.getCurrentLanguage()
            });
            return response.status == RegisterNotificationStatus.Okay;
          } // else no permission
        } // else can't use
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.setNotification", "Push catch", type, error);
        return false;
      }
    } else if (type == "FCM") {
      if (data == null) {
        me._coreLogService.error("InHouseOrderService.setNotification", "FCM needs token as data");
        return false;
      }
      try {
        const response = await me.RegisterNotification({
          type: RegisterNotificationType.FCM,
          data: data,
          language: me._coreLanguageService.getCurrentLanguage()
        });
        return response.status == RegisterNotificationStatus.Okay;
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.setNotification", "FCM catch", type, error);
        return false;
      }
    } else {
      me._coreLogService.error("InHouseOrderService.setNotification", "unknown type", type);
    }
    return false;
  }

  public async GetOrderTypeLocationSettings(): Promise<OrdertypeLocationSettings | null> {
    const me = this;
    try {
      const webshopSettings = await me.GetWebshopSettingsDataModel2();
      const location = me.TableData && me.TableData.location;
      if (!webshopSettings || !location) {
        me.handleError("getOrderTypeLocationSettings: no webshopSettings or no location");
        return null;
      }
      const ih_ordertype = webshopSettings.ordertypes.find((ordertype) => ordertype.id === orderTypes.inHouse);
      if (!ih_ordertype) {
        me.handleError("getOrderTypeLocationSettings: no ih_ordertype found");
        return null;
      }
      const location_settings = ih_ordertype.location_settings.find((loc_settings) => loc_settings.location === location);
      if (!location_settings) {
        me.handleError("getOrderTypeLocationSettings: no location_settings found for location: " + location);
        return null;
      }
      return location_settings;
    } catch (error) {
      me.handleError("getOrderTypeLocationSettings: getWebshopSettingsDataModel catch", error);
      return null;
    }
  }

  public async DigipagerText(): Promise<string> {
    const me = this;
    try {
      const ordertypeLocationSettings = await me.GetOrderTypeLocationSettings();
      return ordertypeLocationSettings ? ordertypeLocationSettings.digipager_optional_text : "";
    } catch (error) {
      me.handleError("DigipagerText: catch", error);
      return "";
    }
  }

  /**
* Checks if ePing notification system is enabled for current location
* @returns true if ePing is enabled globally or for specific location
*/
  public async isEPingEnabled(): Promise<boolean> {
    const settings = await this._webShopService.getWebshopSettingsDataModel();
    if (settings.in_house_order.use_eping_all_locations) {
      return true;
    }
    const ePingLocations = settings.in_house_order.use_eping_locations;
    if (ePingLocations && new Set(ePingLocations).has(this.TableData.location)) {
      return true;
    }
    // No ePing enabled no no need to ask for notification
    return false;
  }

  /**
 * Checks if customer already has a notification set
 * @returns true if notification type is already set (not NONE)
 */
  private async hasExistingNotification(): Promise<boolean> {
    const me = this;
    const table = await me.GetTable(null);
    const customer = table.yasTable.customers.find((cus) => cus.user_token === me.UserToken);
    return customer.notification_typ !== NotificationTyp.NONE;
  }

  /**
   * Attempts to register the device for FCM (Firebase Cloud Messaging) notifications.
   * Retrieves a cached FCM token if available; otherwise, fetches a new one from the backend
   * and stores it locally. If a valid token is available, it sets FCM as the notification method.
   *
   * @returns Promise<boolean> - True if FCM notification was successfully set, otherwise false.
   */
  private async setFCMNotification(): Promise<boolean> {
    let fcmToken = await this._coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.yourAppDeviceFCMToken);
    if (!fcmToken) {
      fcmToken = await this._objObsInjectHelper.yourAppServer.Api.getFcmToken();
      if (fcmToken) {
        await this._coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.yourAppDeviceFCMToken, fcmToken);
      }
    }
    if (fcmToken) {
      return await this.setNotification("FCM", fcmToken);
    }

    return false;
  }

  /**
 * Handles the notification request flow
 * ePing off, Already notified, User declines Otherwise set & true
 */
  private async askForPushNotification(isInHouseGroupOrder: boolean): Promise<NotificationsState> {
    const me = this;
    const useEPing = await me.isEPingEnabled();
    if (!useEPing) {
      return NotificationsState.EPingDisabled;//no eping no need to ask for notification
    }
    const hasNotification = await me.hasExistingNotification();
    if (hasNotification) {
      return NotificationsState.AlreadyExists;
    }
    // display notification dialog
    const accepted = await me.showPushNotificationDialog(isInHouseGroupOrder);
    return accepted ? NotificationsState.Accepted : NotificationsState.Cancelled;
  }

  private PhoneNumberForSMSNotification: string = "";

  /**
   * Shows SMS dialog and saves phone number if entered
   * Does NOT set the notification - caller must call setNotification
   * @returns NotificationsState indicating user action
   */
  private async askForSMSNotification(isInHouseGroupOrder: boolean): Promise<NotificationsState> {
    const me = this;

    const hasNotification = await me.hasExistingNotification();
    if (hasNotification) {
      return NotificationsState.AlreadyExists;
    }
    const phoneNumber = await me.showSMSNotificationDialog(isInHouseGroupOrder);
    if (phoneNumber && phoneNumber.length > 0) {
      me.PhoneNumberForSMSNotification = phoneNumber;
      return NotificationsState.Accepted;
    } else {
      return NotificationsState.Cancelled;
    }
  }

  /**
   * Ensures notification is set before order
   * @param isInHouseGroupOrder - Whether this is an in-house group order
   * @param showSpinner - Callback to show loading spinner
   * @param hideSpinner - Callback to hide loading spinner
   * @returns true if set/not needed, false if cancelled
   */
  public async ensureNotificationIsSet(isInHouseGroupOrder: boolean, showSpinner: () => void, hideSpinner: () => void): Promise<boolean> {
    const me = this;

    // Try FCM notification first on mobile devices
    const isMobile = me._coreCOMService.environment.client.isMobile;
    if (isMobile) {
      showSpinner();
      const fcmSuccess = await me.setFCMNotification();
      hideSpinner();
      if (fcmSuccess) {
        return true;
      }
    }
    // Ask user for push notification preference
    const pushNotificationState = await me.askForPushNotification(isInHouseGroupOrder);
    if (pushNotificationState === NotificationsState.EPingDisabled ||
      pushNotificationState === NotificationsState.AlreadyExists) {
      return true;
    }
    if (pushNotificationState === NotificationsState.Cancelled) {
      return false;
    }
    if (pushNotificationState === NotificationsState.Accepted) {
      showSpinner();
      const success = await me.setNotification("Push", null);
      hideSpinner();
      if (success) {
        return true;
      }
      // Fallback to SMS if push notification fails
      return await me.trySetSMSNotification(isInHouseGroupOrder, showSpinner, hideSpinner);
    }

    return false;
  }

  /**
   * Tries to set SMS notification with retry loop
   * User can cancel - order will be aborted, but on next "Add to cart" click SMS dialog appears directly
   * @param isInHouseGroupOrder - Whether this is an in-house group order
   * @param showSpinner - Callback to show loading spinner
   * @param hideSpinner - Callback to hide loading spinner
   * @returns true if SMS set, false if user cancelled
   */
  private async trySetSMSNotification(isInHouseGroupOrder: boolean, showSpinner: () => void, hideSpinner: () => void): Promise<boolean> {
    const me = this;
    while (true) {
      const smsNotificationState = await me.askForSMSNotification(isInHouseGroupOrder);
      if (smsNotificationState === NotificationsState.AlreadyExists) {
        return true;
      }
      if (smsNotificationState === NotificationsState.Cancelled) {
        return false;
      }
      if (smsNotificationState === NotificationsState.Accepted) {
        showSpinner();
        const phoneNumber = me.PhoneNumberForSMSNotification;
        const success = await me.setNotification("SMS", phoneNumber);
        hideSpinner();
        if (success) {
          return true;
        }
      }
    }
  }

  private handleError(message: string, error?: any) {
    const me = this;
    me._coreLogService.error("InHouseOrderService", message, error);
  }

  //#endregion

  //#region Dialoge

  /**
   * Shows notification dialog to user
   * @returns true if user accepts notification, false if declined
   */
  private async showPushNotificationDialog(isInHouseGroupOrder: boolean): Promise<boolean> {
    const me = this;
    const digipagertext = await me.DigipagerText();
    return new Promise<boolean>((resolve) => {
      const dialog = me._bottomSheetHelperService.open(NotificationsDialogComponent, {
        autoFocus: false,
        disableClose: true,
        panelClass: "mat-bottom-sheet-container-medium",
        data: {
          digiPagerText: digipagertext,
          isInHouseGroupOrder: isInHouseGroupOrder
        },
      });

      dialog.afterDismissed().subscribe((accept) => {
        resolve(accept === true);
      });
    });
  }

  /**
 * Shows SMS notification dialog and returns phone number or null
 * @returns phone number string if user entered it, null if cancelled
 */
  private async showSMSNotificationDialog(isInHouseGroupOrder: boolean): Promise<string> {
    const me = this;

    return new Promise<string>((resolve) => {
      const dialog = me._bottomSheetHelperService.open(NotificateViaSMSDialogComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          isInHouseGroupOrder: isInHouseGroupOrder
        }
      });

      dialog.afterDismissed().subscribe((number) => {
        resolve(number);
      });
    });
  }

  /** Warning dialog: kein standort */
  private OpenWarningNoLocation() {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phInHouse_NoQRCode_Warning_Title"
        , content: "phInHouse_NoQRCode_Warning_Description"
        , btnLabel: "phInHouse_NoQRCode_Warning_Button_Text"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningButtomSheet.afterDismissed().subscribe((result) => {
      if (result) {
        me._router.navigate(["/"]); // Home
      }
    });
  }

  /** Avaliable service time dialog */
  private openAvaliableServiceTime(location: LocationWebshopViewModel, serviceMode: number) {
    const me = this;
    const availableButtomSheet = me._bottomSheetHelperService.open(AvailableServiceTimeComponent, {
      data: { isLocationOpen: location.open, locationOpenDays: location.openDays, serviceMode: serviceMode },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    availableButtomSheet.afterDismissed().subscribe((result: boolean) => {
      if (result) {
        me._router.navigate(["/"]); // Home
      }
    });
  }

  /** hält die referenz zum LostConnection Dialog, falls die verbindung wiederhergestellt wird. */
  private _LostConnectionDlg: MatBottomSheetRef<WarningdialogComponent, boolean> = null;

  /** Warning dialog: Lost connection to the restaurant  */
  private OpenWarningLostConnection() {
    const me = this;
    if (me._LostConnectionDlg == null) {
      me._LostConnectionDlg = me._bottomSheetHelperService.open(WarningdialogComponent, {
        data: {
          title: "phInHouse_LostConnection_Title"
          , content: "phInHouse_LostConnection_Description"
          , btnLabel: "phInHouse_Continue_Btn"
        },
        panelClass: "mat-bottom-sheet-container-medium"
      });
      me._LostConnectionDlg.afterDismissed().subscribe((result) => {
        me._LostConnectionDlg = null;
        if (result) {
          me._routerHelperService.setRouteTargetDataByKey("isGroupOrder", me.GroupCode != "");
          me._router.navigate(["/qrcodescanner"]);
        }
      });
    }
  }

  /** schließt den LostConnection, falls dieser noch offen ist */
  private CloseWarningLostConnection() {
    const me = this;
    if (me._LostConnectionDlg != null) {
      me._LostConnectionDlg.dismiss(false); // false = kein redirect
    }
  }

  /** Warning dialog:The table was closed */
  private OpenWarningTableClosed() {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phInHouse_TableClosed_Title"
        , content: "phInHouse_TableClosed_Description"
        , btnLabel: "phInHouse_Continue_Btn"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningButtomSheet.afterDismissed().subscribe((result) => {
      if (result) {
        me._routerHelperService.setRouteTargetDataByKey("isGroupOrder", me.GroupCode != "");
        me._router.navigate(["/qrcodescanner"]);
      }
    });
  }

  //#endregion

  /** Stellt eine Verbindung zum Standort YourAppServer her */
  public async Connect(location: number): Promise<void> {
    const me = this;
    me.autoreconnect = true;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    try {
      await socket.Connect(location);
      return; // connect success
    } catch (error) {
      me._coreLogService.error("InHouseOrderService.Connect", "socket.Connect.catch", error);
      me._coreLogService.info("InHouseOrderService.Connect", "try Connect after delay");
      await Utils.wait(2000); // wartet 2 Secunden und versucht es erneut
      return socket.Connect(location);
    }
  }

  /** Damit nicht zwei Reconnects Parallel stattfinden, wird diese Varible genutzt */
  private _IsInReconnection = false;
  /** Stellt eine Verbindung letzten Standort YourAppServer her */
  private async Reconnect(old_data: CachebleData): Promise<void> {
    const me = this;
    if (me._IsInReconnection) {
      me._coreLogService.info("InHouseOrderService.Reconnect", "_IsInReconnection, skip Reconnect call");
      return Promise.resolve();
    }

    me.autoreconnect = true;
    if (old_data) {
      me._IsInReconnection = true;
      const socket = me._objObsInjectHelper.yourAppServer.Socket;
      try {
        try {
          await socket.Connect(socket.Connection.location);
        } catch (error) {
          me._coreLogService.error("InHouseOrderService.Reconnect", "socket.Connect1.catch, wait and try again", error);
          await Utils.wait(2000); // versuche nach 2 Sekunden erneut, bei einem Ausfall ist die Internet Verbindung am Smartphone unzuverlässig
          await socket.Connect(socket.Connection.location);
        }
        // try refresh old data
        const result = await me._SetTableCode(old_data.tableData, old_data.posTableNr, old_data.groupName, [], old_data.groupCode, old_data.groupCreator, old_data.userNickname, old_data.placeNo, old_data.userToken);
        if (result.result.success) {
          await me.GetTable(TableData.All); // refresch after reconnect all table data
        } else {
          me.Disconnect();
        }
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.Reconnect", "catch", error);
        me.Disconnect();
      }
      me._IsInReconnection = false;
    } else {
      me._coreLogService.error("InHouseOrderService.Reconnect", "no old_data for reconnect");
    }
  }

  /** Trennt die offne Verbindung */
  public Disconnect(cleanup: boolean = true): Promise<void> {
    const me = this;
    me.autoreconnect = false;
    if (cleanup) {
      me.CleanUp();
    }
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    return socket.Disconnect(cleanup);
  }

  /** Bereinigt die gecacheten Datan */
  private CleanUp(): void {
    const me = this;
    me._ChangeUiData(new TableInfo());
    me._currentData = new CachebleData();
    me._table = null;
    me._suspendedConnection = null;
  }

  //#region zu WebShopService Wechseln? Achtung es bekommt die Settings zu einem späteren zeitpunkt

  private _webshopSettingsObsServ: IObjectObserver<WebshopSettingsDataModel2>;
  private _webshopSettingsChanged: Subscription;
  private _webshopSettingsDataModel: WebshopSettingsDataModel2;
  private GetWebshopSettingsDataModel2(): Promise<WebshopSettingsDataModel2> {
    const me = this;
    return new Promise<any>(async (resolve, reject) => {
      if (!me._webshopSettingsObsServ) {
        me._webshopSettingsObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<WebshopSettingsDataModel2>(ContentType.WebshopSettings, me._objObsInjectHelper);
        me._webshopSettingsChanged = me._webshopSettingsObsServ.ObserveChanges.subscribe(async () => {
          try {
            me._webshopSettingsDataModel = await me._webshopSettingsObsServ.GetObject(WebshopSettingsDMKey);
          } catch (error) {
            me._coreLogService.error("InHouseOrderService.GetWebshopSettingsDataModel2", "_webshopSettingsObsServ.GetObject.catch", error);
          }
        });
      }

      if (me._webshopSettingsDataModel) {
        resolve(me._webshopSettingsDataModel);
      } else {
        try {
          me._webshopSettingsDataModel = await me._webshopSettingsObsServ.GetObject(WebshopSettingsDMKey);
          resolve(me._webshopSettingsDataModel);
        } catch (error) {
          me._coreLogService.error("InHouseOrderService.GetWebshopSettingsDataModel2", "_webshopSettingsObsServ.GetObject.catch", error);
          reject();
        }
      }
    });
  }

  /** Sucht Tisch informationen zum Tisch QRCode, wenn es keine findet kommt null */
  public GetTableQRCodeData(tableQRCode: string): Promise<ITableQRCode> {
    const me = this;
    return new Promise<ITableQRCode>(async (resolve, reject) => {
      try {
        let servicelocation: TableQRCode = null;
        const webshopSettings = await me.GetWebshopSettingsDataModel2();
        for (const location_qrCode of webshopSettings.customer_location_qrCode) {
          for (const qrCode of location_qrCode.tableQRCode) {
            if (qrCode.qrCode.toUpperCase() == tableQRCode.toUpperCase()) {
              servicelocation = new TableQRCode();
              servicelocation.qrCode = qrCode.qrCode;
              servicelocation.location = location_qrCode.locationId;
              servicelocation.tableNr = qrCode.tableNr;
              servicelocation.tableName = qrCode.tableName;
              servicelocation.mandatory_Payment = qrCode.mandatory_Payment;
              break;
            }
          }
          if (servicelocation) {
            break; // break search if found
          }
        }
        resolve(servicelocation);
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.GetTableQRCodeData", "catch", error);
        reject();
      }
    });
  }

  private GetTableFromNumber(location: number, table_no: string): Promise<ITableQRCode> {
    const me = this;
    return new Promise<ITableQRCode>(async (resolve, reject) => {
      try {
        let servicelocation: TableQRCode = null;
        const webshopSettings = await me.GetWebshopSettingsDataModel2();
        for (const location_qrCode of webshopSettings.customer_location_qrCode) {
          if (location_qrCode.locationId != location)
            continue; // search for right location

          for (const qrCode of location_qrCode.tableQRCode) {
            if (qrCode.tableNr == table_no) {
              servicelocation = new TableQRCode();
              servicelocation.qrCode = qrCode.qrCode;
              servicelocation.location = location_qrCode.locationId;
              servicelocation.tableNr = qrCode.tableNr;
              servicelocation.tableName = qrCode.tableName;
              break;
            }
          }
          if (servicelocation) {
            break; // break search if found
          }
        }
        resolve(servicelocation);
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.GetTableFromNumber", "catch", error);
        reject();
      }
    });
  }

  //#endregion

  //#region Verarbeitungs Funktionen

  /** schreibt _currentData in den cache */
  private CacheData(): Promise<void> {
    const me = this;
    const now = moment();
    me._currentData.cachedAt_YMD = Utils.GetYMDFromMoment(now);
    me._currentData.cachedAt_HMS = Utils.GetHMSFromMoment(now);
    return me._coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.inHouseOrder, me._currentData);
  }

  /** bereinigt den cache */
  private CleanupCacheData(): Promise<void> {
    return this._coreCOMService.environment.valueStorage.remove(StorageHive.Local, LocalKeys.inHouseOrder);
  }

  /** Ermittelt zuletzt gespeicherte, sonst null */
  private LoadCachedData(): Promise<CachebleData> {
    const me = this;
    return new Promise<CachebleData>(async (resolve, reject) => {
      try {
        let cachedData: CachebleData = await me._coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.inHouseOrder);
        if (cachedData) {
          // prüfen ob die Daten noch aktuell sind (maximal 24 Stunden)
          const cachedAt = Utils.GetMomentFromInt(cachedData.cachedAt_YMD, cachedData.cachedAt_HMS);
          const now = moment()
          // daten müssen in der vergangenheit liegen aber nicht älter als 24 Stunden
          if (cachedAt > now || moment.duration(now.diff(cachedAt)).asHours() >= 24) {
            me.CleanupCacheData(); // no wait need, safe time
            cachedData = null;
          }
          // todo eventuell hier auch die öffnungszeiten prüfen wie WebShopService submitQRCodeData
        }
        resolve(cachedData);
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.LoadCachedData", "valueStorage.get.catch", error);
        reject(error);
      }
    });
  }

  /** Prüfung ob die gecacheten */
  private async CheckCachedDataValide(data: CachebleData): Promise<boolean> {
    const me = this;
    let valide = false;
    try {
      // versuche GetPlace ein Platz am Tisch zu erhalten, wenn möglich, alles okay
      const req: req_GetPlace = {
        table_no: data.posTableNr,
        group_name: data.groupName,
        group_code: data.groupCode,
        release_group_names: [],
        nickname: data.userNickname,
        place_no: data.placeNo,
        user_token: data.userToken
      };

      // wenn der Standort sich ändert auch die Verbindung neu aufbauen
      if (me.Status !== ConnectionState.Disconnected && me._currentData.tableData.location !== data.tableData.location) {
        await me.Disconnect();
      }
      if (me.Status == ConnectionState.Disconnected) {
        await me.Connect(data.tableData.location);
      }
      // erhalte neuen/alten Platz am Tisch
      const res = await me._GetPlace(req);
      valide = res.status == GetPlaceStatus.Okay;
    } catch (error) {
      me._coreLogService.error("InHouseOrderService.CheckCachedDataValide", "_GetPlace.catch", error);
      // valide bleibt false 
    }
    return valide;
  }

  /** Synchronisiert SignalR mit Owin auf dem Server */
  public SyncConnectionWithServer(): Promise<boolean> {
    const me = this;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    return socket.SyncConnectionWithServer();
  }

  /** Ermittelt vom Server ob InHouse eine Zahlungsart hat */
  public HasPaymentOnServer(): Promise<boolean> {
    const me = this;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    return socket.HasPaymentOnServer(me.TableData.location);
  }

  /** Versucht aus dem Speicher den Gast erneut an den Tisch zu setzen, wenn es scheitert wird null returnt */
  public TryGetBackToStoredTableOrGroup(): Promise<SetTableDone> {
    const me = this;
    return new Promise<SetTableDone>(async (resolve, reject) => {
      try {
        const cashedData = await me.LoadCachedData();
        if (cashedData) {
          if (cashedData.userToken.length > 0) {
            // zuletzt war ein Platz vorhanden, also ein versuch den alten Platz erneut zu erhalten
            const oldPlace = await me._SetTableCode(cashedData.tableData, cashedData.posTableNr, cashedData.groupName, [], cashedData.groupCode, cashedData.groupCreator, cashedData.userNickname, cashedData.placeNo, cashedData.userToken);

            if (oldPlace.need_new_scan) {
              // alter Platz nicht möglich, cache kann aufgeräumt werden
              me.CleanupCacheData(); // no wait need, try it in background
            } else if (oldPlace.result.success) {
              // es gibt neuen cache, beim nächsten lauf braucht es um abgefragt zu werden
              me._webShopService.syncYASServerBasketToLocal(); // refresh UI
              me.CloseWarningLostConnection();
            } // else cache behalten, scheint ein anderes problem zu sein

            // try close open connection
            if (!oldPlace.result.success && me.Status !== ConnectionState.Disconnected) {
              me.Disconnect(); // no wait need, try it in background
            }
            resolve(oldPlace.result);
          } else {
            // die gespeicheren Daten sind ungültig
            me.CleanupCacheData(); // no wait need, try it in background
            resolve(null);
          }
        } else {
          // no cached data
          resolve(null);
        }
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.TryGetBackToStoredTable", "catch", error);
        // try close open connection
        if (me.Status !== ConnectionState.Disconnected) {
          me.Disconnect(); // no wait need, try it in background
        }
        reject(error);
      }
    });
  }

  /** Wird beim Scannen von Tischcode aufgerufen.
   * Wenn need_new_scan=true zurückkommt, muss der TischCode Erneut gescannt werden, bestehenden nicht mehr verwenden.
   * @param tableQRCode Tisch QR Code
   * @param nickname Gast Nickname
   */
  public SetTableCode(tableQRCode: string, nickname: string): Promise<SetTableDone> {
    const me = this;
    return new Promise<SetTableDone>(async (resolve, reject) => {
      try {
        let tableData: ITableQRCode = null;
        let oldPosTableNr: string = null;
        let oldPalceNo: number = null;
        let oldUserToken: string = null;
        if (me._currentData.tableData.qrCode.length > 0 && me._currentData.tableData.qrCode == tableQRCode) {
          tableData = me._currentData.tableData;
          // try get old place
          oldPosTableNr = me._currentData.posTableNr;
          oldPalceNo = me._currentData.placeNo;
          oldUserToken = me._currentData.userToken;
        } else {
          tableData = await me.GetTableQRCodeData(tableQRCode);
          // try load cached data
          const cachedData = await me.LoadCachedData();
          if (cachedData && cachedData.tableData && cachedData.tableData.qrCode === tableQRCode) {
            oldPosTableNr = cachedData.posTableNr;
            oldPalceNo = cachedData.placeNo;
            oldUserToken = cachedData.userToken;
          }
        }
        let place_data: SetTableDone = null;
        // try gets old place
        if (oldPosTableNr !== null && oldPalceNo !== null && oldUserToken !== null) {
          const oldPlace = await me._SetTableCode(tableData, oldPosTableNr, "", [], "", "", nickname, oldPalceNo, oldUserToken);
          if (!oldPlace.need_new_scan && oldPlace.result.success) {
            place_data = oldPlace.result;
          }
        }
        // gets new place if not a group
        if (place_data == null) {
          const newPlace = await me._SetTableCode(tableData, tableData.tableNr, "", [], "", "", nickname, null, null);
          place_data = newPlace.result;
        }
        resolve(place_data);
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.SetTableCode", "catch", error);
        reject(error);
      }
    });
  }

  /** versucht eine Gruppe zu erzeugen */
  public CreateGroup(tableQRCode: string, groupName: string, releaseGroupNames: string[], nickname: string): Promise<SetTableDone> {
    const me = this;
    if (Utils.IsNullOrWhiteSpace(tableQRCode) || Utils.IsNullOrWhiteSpace(groupName)) {
      return Promise.reject("tableQRCode or groupName not found");
    }
    return new Promise<SetTableDone>(async (resolve, reject) => {
      try {
        let tableData = await me.GetTableQRCodeData(tableQRCode);
        // gets new group and place
        const newGroupAndPlace = await me._SetTableCode(tableData, tableData.tableNr, groupName, releaseGroupNames, "", nickname, nickname, null, null);
        resolve(newGroupAndPlace.result);
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.CreateGroupCode", "catch", error);
        reject(error);
      }
    });
  }

  /** versucht mit dem Gruppencode eine Gruppe bei zu treten */
  public JoinGroupCode(groupCode: string, nickname: string): Promise<SetTableDone> {
    const me = this;
    if (Utils.IsNullOrWhiteSpace(groupCode)) {
      return Promise.reject("groupCode not found");
    }
    return new Promise<SetTableDone>(async (resolve, reject) => {
      try {
        let tableData: ITableQRCode = null;
        let groupName = null;
        let groupCreator = null;
        let oldPalceNo = null;
        let oldUserToken = null;
        if (me._currentData.groupCode.length > 0 && me._currentData.groupCode == groupCode) {
          // try get old place
          tableData = me._currentData.tableData;
          groupName = me._currentData.groupName;
          groupCreator = me._currentData.groupCreator;
          oldPalceNo = me._currentData.placeNo;
          oldUserToken = me._currentData.userToken;
          nickname = me._currentData.userNickname; // alten namen verwenden
        } else {
          const info = await me.GetInfoFromGroupcode(groupCode);
          if (info.group_code_info.valide) {
            tableData = info.tableQRCode;
            groupName = info.group_code_info.group_name;
            groupCreator = info.group_code_info.group_creator;
          }
          // try load cached data
          const cachedData = await me.LoadCachedData();
          if (cachedData && cachedData.groupCode && cachedData.groupCode === groupCode) {
            oldPalceNo = cachedData.placeNo;
            oldUserToken = cachedData.userToken;
            nickname = cachedData.userNickname; // alten namen verwenden
          }
        }
        let place_data: SetTableDone = null;
        // try gets old place
        if (oldPalceNo !== null && oldUserToken !== null) {
          const oldPlace = await me._SetTableCode(tableData, tableData.tableNr, groupName, [], groupCode, groupCreator, nickname, oldPalceNo, oldUserToken);
          if (!oldPlace.need_new_scan && oldPlace.result.success) {
            place_data = oldPlace.result;
          }
        }
        // gets new place
        if (place_data == null) {
          const newPlace = await me._SetTableCode(tableData, tableData.tableNr, groupName, [], groupCode, groupCreator, nickname, null, null);
          place_data = newPlace.result;
        }
        return resolve(place_data);
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.SetGroupCode", "catch", error);
        return reject(error);
      }
    });
  }

  /** Interne Funktion um einen Gast an einen Tisch zu plazieren */
  private _SetTableCode(tableData: ITableQRCode, posTableNr: string, groupName: string, releaseGroupNames: string[], groupCode: string, groupCreator: string, nickname: string, placeNo: number | null, userToken: string | null): Promise<{ need_new_scan: boolean, result: SetTableDone }> {
    const me = this;
    if (!tableData) {
      return Promise.reject("tableData not found");
    }
    if (!tableData.location) {
      return Promise.reject("tableData.location not found");
    }
    return new Promise<{ need_new_scan: boolean, result: SetTableDone }>(async (resolve, reject) => {
      try {
        const result = new SetTableDone();
        result.success = false;

        // wenn der Standort sich ändert auch die Verbindung neu aufbauen
        if (me.Status !== ConnectionState.Disconnected && me._currentData.tableData.location !== tableData.location) {
          await me.Disconnect();
        }
        if (me.Status == ConnectionState.Disconnected) {
          await me.Connect(tableData.location);
        }

        // versuche GetPlace ein Platz am Tisch zu erhalten, oder den Gast ein neuen Nicknamen zuzuweisen
        const req: req_GetPlace = {
          table_no: posTableNr,
          group_name: groupName,
          group_code: groupCode,
          release_group_names: releaseGroupNames,
          nickname: nickname,
          place_no: placeNo,
          user_token: userToken
        };

        // erhalte neuen/alten Platz am Tisch
        const res = await me._GetPlace(req);
        if (res.status < 0) {
          return reject("place on table error " + res.status);
        }

        let need_new_scan = false;
        result.status = res.status;
        if (result.status == GetPlaceStatus.Okay) {
          me._table = null;
          me._currentData.tableData = tableData;
          me._currentData.posTableNr = res.table_no;
          me._currentData.groupName = res.group_name;
          me._currentData.groupCode = res.group_code;
          me._currentData.groupCreator = groupCreator;
          me._currentData.userNickname = nickname;
          me._currentData.placeNo = res.place_no;
          me._currentData.userToken = res.user_token;
          me.CacheData(); // async no wait, etwas zeit sparen

          const table_info = new TableInfo();
          table_info.table_no = me._currentData.tableData.tableNr;
          table_info.place_no = me._currentData.placeNo;
          table_info.group_name = me._currentData.groupName;
          table_info.group_code = me._currentData.groupCode;
          table_info.user_nickname = nickname;
          table_info.open_amount = res.open_amount;
          table_info.open_price = Utils.centsToCurrency(res.open_price);
          table_info.customer_count = res.customer_count;
          me._ChangeUiData(table_info);
          // set WebShop Data for InHouseOrder
          await me._webShopService.setServiceMode(WebShopMode.OrderToTable);
          await me._webShopService.setServiceLocationByID(tableData.location);
          me._webShopService.qrCode = tableData.qrCode;
          me._webShopService.tableName = tableData.tableName;
          result.table_info = table_info;
          result.success = true;

          // für die Warnung, dass der Tisch keine Rabatt erlaubt
          try {
            await me._webShopService.onUserChange();
          } catch (error) {
            me._coreLogService.error("InHouseOrderService.tryOpenTableCode", "_webShopService.onUserChange() catch", error);
          }
        } else {
          need_new_scan = !Utils.IsNullOrEmpty(userToken);
          me._coreLogService.info("InHouseOrderService._SetTableCode", "GetPlace faild", req);
        }

        return resolve({
          need_new_scan: need_new_scan,
          result: result
        });
      } catch (error) {
        me._coreLogService.error("InHouseOrderService._SetTableCode", "catch", error);
        return reject("internal error");
      }
    });
  }

  /** Ermitteln der Informationen zur Gruppe */
  public GetInfoFromGroupcode(group_code: string): Promise<GroupInfo> {
    const me = this;
    return new Promise<GroupInfo>(async (resolve, reject) => {
      try {
        let result: GroupInfo = { group_code_info: null, tableQRCode: null };
        result.group_code_info = await me.GetGroupcodeInfo(group_code);
        if (result.group_code_info.valide) {
          result.tableQRCode = await me.GetTableFromNumber(result.group_code_info.location, result.group_code_info.table_no);
          result.group_code_info.valide = result.tableQRCode != null; // refresh valide state
        }
        resolve(result);
      } catch (error) {
        reject(error);
      }
    })
  }

  /** Ermittelt vom aktuellen tisch bzw eine bestimmte information */
  public GetTable(table_data: TableData | null): Promise<Table> {
    const me = this;
    return new Promise<Table>(async (resolve, reject) => {
      try {
        if (!me._table || table_data) {
          // wenn kein Tisch gecachet ist, alles Abrufen
          if (!me._table) {
            table_data = TableData.All;
          }
          const currentTable = await me._GetTable(table_data);
          if (!me._table) {
            me._table = new Table();
          }
          if (currentTable.status == GetTableStatus.Okay) {
            switch (table_data) {
              case TableData.All:
                me._table.posTable = currentTable.pos_table;
                me._table.yasTable = currentTable.yas_table;
                break;
              case TableData.MyBasked:
                me._table.yasTable.user_basket_items = currentTable.yas_table.user_basket_items;
                break;
              case TableData.GroupBasked:
                me._table.yasTable.group_basket_items = currentTable.yas_table.group_basket_items;
                break;
              case TableData.OrderdItems:
                me._table.posTable.items = currentTable.pos_table.items;
                break;
              case TableData.PayStatus:
                me._table.yasTable.payments = currentTable.yas_table.payments;
                break;
              case TableData.Customers:
                me._table.yasTable.customers = currentTable.yas_table.customers;
                break;
              case TableData.Locked:
                me._table.yasTable.locked = currentTable.yas_table.locked;
                break;
              default:
                reject("unknown TableData type");
                return;
            }
            // todo hier eigendlich event für table change aufrufen, aber dazu sollte YAS immer den client informiren auch wenn es die eigene änderung ist
          } else {
            reject("no table");
            return;
          }

          // ermitteln der CustomerCount und OpenItems/-Price um die UI zu Aktualisieren
          let customer_count: number = 0;
          let open_amount: number = 0;
          let open_price: number = 0;
          if (me._table.yasTable && me._table.yasTable.customers) {
            customer_count = me._table.yasTable.customers.length;
          }
          if (me._table.posTable && me._table.posTable.items) {
            me._table.posTable.items.forEach(item => {
              open_amount += item.amount;
              open_price += item.price * item.amount;
            });
          }
          const newUiData = Utils.GetExtend(new TableInfo(), { ...me.UiData });
          newUiData.customer_count = customer_count;
          newUiData.open_amount = open_amount;
          newUiData.open_price = Utils.centsToCurrency(open_price);
          me._ChangeUiData(newUiData);
        } // else table_data == null, aktuellen Tisch ermitteln, ohne Abruf vom Server

        resolve(me._table);
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.GetTable", "catch", error);
        reject(error);
      }
    });
  }

  /** Ermitlung der Plätze mit Bestellen Artikeln nach Gästen vom Tisch */
  public GetSeatsFromTable(table: Table): Seats {
    const me = this;
    // customer auslesen
    const newSeats: Seats = {};
    table.yasTable.customers.forEach(customer => {
      newSeats[customer.user_token] = { customer: customer, pos_items: [] }
    });
    newSeats[""] = { customer: null, pos_items: [] } // userToken = "" > ohne Zuordnung
    // bestellte artikel auslesen
    table.posTable.items.forEach(item => {
      try {
        // Customer ist momentan nur dem POS bekannt
        if (!newSeats[item.userToken]) {
          const dummyCustomer = new Customer();
          dummyCustomer.user_token = item.userToken;
          dummyCustomer.guest = true;
          dummyCustomer.place_no = item.placeNumber;
          newSeats[item.userToken] = { customer: dummyCustomer, pos_items: [] }
        }
        // Item dem Platz zuordnen
        newSeats[item.userToken].pos_items.push(item);
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.getSeatsFromTable", "table.posTable.items.forEach.catch", error, item);
      }
    });
    return newSeats;
  }

  /** ermittelt aus dem Table die anzahl der nicht abgeholten Artikel */
  public GetReadyForPickUpCount(table: Table, exclude_ids: number[] = []): number {
    const me = this;
    let readyForPickUpCount = 0;
    try {
      readyForPickUpCount = me.GetItemsReadyForPickUp(table, exclude_ids).reduce((sum, item) => sum + item.amount, readyForPickUpCount);
    } catch (error) {
      me._coreLogService.error("InHouseOrderService.getSeatsFromTable", "table.posTable.items.forEach.catch", error);
    }
    return readyForPickUpCount;
  }

  /** ermittelt die Artikel welche zum abholen bereit sind */
  public GetItemsReadyForPickUp(table: Table, exclude_ids: number[] = []): POSTable_Item[] {
    const me = this;
    try {
      const currentUserToken = me.UserToken;
      const customer = table.yasTable.customers.find((cus) => cus.user_token == currentUserToken);
      return table.posTable.items.filter((item) => {
        return (item.userToken == currentUserToken &&
          item.status == POSTable_ItemStatus.PickUpReady &&
          (!customer.noticed_items.includes(item.id) || exclude_ids.includes(item.id)) &&
          !me.IsItemAutoPickedUp(item));
      })
    } catch (error) {
      me._coreLogService.error("InHouseOrderService.GetItemsReadyForPickUp", "table.posTable.items.forEach.catch", error);
    }
    return [];
  }

  /** item gilt nach 10 Minuten automatisch als abgeholt */
  public IsItemAutoPickedUp(item: POSTable_Item): boolean {
    if (item.readyAt_YMD > 0 && item.status == POSTable_ItemStatus.PickUpReady) {
      const now = moment();
      const auto_pickedup_at = Utils.GetMomentFromInt(item.readyAt_YMD, item.readyAt_HMS).add(10, "minutes");
      return now > auto_pickedup_at;
    } else {
      return false;
    }
  }

  /** generiert ein InHouseDataModel für die Communikation mit dem Server */
  public GetInHouseDataModelForCheckout(): InHouseDataModel {
    const me = this;
    if (me._currentData.placeNo > 0) {
      const dataModel = new InHouseDataModel();
      dataModel.table_no = me._currentData.posTableNr;
      dataModel.group_name = me._currentData.groupName;
      dataModel.group_code = me._currentData.groupCode;
      dataModel.place_no = me._currentData.placeNo;
      dataModel.user_token = me._currentData.userToken;
      const socket = me._objObsInjectHelper.yourAppServer.Socket;
      dataModel.auth_token = socket.Connection.token;
      return dataModel;
    } else {
      return null;
    }
  }

  /** Schliest von sichaus die verbindung zum Tisch und löscht den Cache um ein Wiederverbinden zu verhindern.
   * Wird genutzt wenn Bezahlen am Tisch erfolgt. Da der Tisch am POS offenbleibt, um die Zahlung durchführen zu können.
   * (Grund, Chrmoebrowser im iOS schaft sich schnell wieder zu verbinden, und erhält den alten Platz zurück)
   */
  public async CloseTableAndCleanUpAfterPayAtWaiter(): Promise<void> {
    const me = this;
    try {
      // try Disconnect
      await me.Disconnect(true);
    } catch (error) {
      // ein Fehler kann auftretten, wenn bereits durch ein Event die Verbindung unterbrochen wurde
      me._coreLogService.error("InHouseOrderService.CloseTableAndCleanUpAfterPayAtWaiter", "Disconnect.catch", error);
    }
    await me.CleanupCacheData();
    await me._webShopService.resetWebshopService();
  }

  //#endregion

  //#region Group basket operations

  /**
     * Updates a single item in the group basket
     * @param item
     * @returns update state
     *
     * Note: This method uses Full sync mode to preserve item positions in the basket.
     * The item is identified by the combination of user_token, position, and product_id.
     */
  public async GroupBasket_UpdateItem(item: BasketItem): Promise<boolean> {
    const me = this;
    // Get all current group basket items from the table
    const table = await me.GetTable(null);
    const allGroupBasketItems = table.yasTable.group_basket_items;

    // Find and update the specific item in the array
    const itemIndex = allGroupBasketItems.findIndex(i =>
      i.user_token === item.user_token &&
      i.position === item.position &&
      i.product_id === item.product_id
    );

    if (itemIndex >= 0) {
      // Replace the item at the found index with the updated item
      allGroupBasketItems[itemIndex] = item;
      // Send full basket update to preserve positions
      const request: req_ChangeGroupBasket = {
        change_type: ChangeGroupBasketChangeType.Full,
        return_items: true,
        items: allGroupBasketItems
      };
      try {
        const response = await me.ChangeGroupBasket(request);
        if (response.status !== ChangeGroupBasketStatus.Okay) {
          me._coreLogService.error("InHouseOrderService.GroupBasket_UpdateItem failed:", response.status.toString());
          return false;
        } else {
          return true;
        }
      } catch (error) {
        me._coreLogService.error("GroupOrderOverview.updateItem error:", error);
        return false;
      }
    } else {
      me._coreLogService.error("InHouseOrderService.GroupBasket_UpdateItem", "update error", "Item not found in group basket");
      return false;
    }
  }

  /**
   * Increases item amount by 1 in the group basket
   * Item is identified by user_token + position from the BasketItem
   * Only allowed for group creator and owner of the item
   */
  public async GroupBasket_AddCount(item: BasketItem): Promise<void> {
    const me = this;
    const nextCount = item.amount + 1;
    let nextItem = Utils.GetCopy(item);
    nextItem.amount = nextCount;
    const request: req_ChangeGroupBasket = {
      change_type: ChangeGroupBasketChangeType.Diff,
      return_items: true,
      items: [nextItem]
    };
    try {
      const response = await me.ChangeGroupBasket(request);
      if (response.status === ChangeGroupBasketStatus.Okay) {
        item.amount = nextCount;
      } else {
        me._coreLogService.error("InHouseOrderService.GroupBasket_AddCount", "update failed", response.status.toString());
      }
    } catch (error) {
      me._coreLogService.error("InHouseOrderService.GroupBasket_AddCount", "update error", error);
    }
  }

  /**
   * Decreases item amount by 1 in the group basket
   * If amount reaches 0, item will be removed from the basket
   * Item is identified by user_token + position from the BasketItem
   * Only allowed for group creator and owner of the item
   */
  public async GroupBasket_RemoveCount(item: BasketItem): Promise<void> {
    const me = this;
    const nextCount = item.amount - 1;
    if (nextCount <= 0) {
      // Sende Remove als Diff (leeres Item mit amount 0 oder per remove-Flag, je nach API)
      // Hier: amount auf 0 setzen und als Diff senden
      let removeItem = Utils.GetCopy(item);
      removeItem.amount = 0;
      const request: req_ChangeGroupBasket = {
        change_type: ChangeGroupBasketChangeType.Diff,
        return_items: true,
        items: [removeItem]
      };
      try {
        const response = await me.ChangeGroupBasket(request);
        if (response.status !== ChangeGroupBasketStatus.Okay) {
          me._coreLogService.error("InHouseOrderService.GroupBasket_RemoveCount failed:", response.status.toString());
        }
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.GroupBasket_RemoveCount error:", error);
      }
    } else {
      let nextItem = Utils.GetCopy(item);
      nextItem.amount = nextCount;
      const request: req_ChangeGroupBasket = {
        change_type: ChangeGroupBasketChangeType.Diff,
        return_items: true,
        items: [nextItem]
      };
      try {
        const response = await me.ChangeGroupBasket(request);
        if (response.status === ChangeGroupBasketStatus.Okay) {
          item.amount = nextCount;
        } else {
          me._coreLogService.error("InHouseOrderService.GroupBasket_RemoveCount", "update failed", response.status.toString());
        }
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.GroupBasket_RemoveCount", "update error", error);
      }
    }
  }

  //#endregion

  //#region Events

  private _onTableChanged: Subject<TableChangedType> = new Subject();
  /** Informiert bei Änderung vom Tisch ein YourAppClient */
  public get ObserveOnTableChanged(): Observable<TableChangedType> {
    return this._onTableChanged;
  }
  private async OnTableChanged(...params: any[]): Promise<void> {
    const me = this;
    switch (params[0] /* 0=Version */) {
      case 1:
        const changed_type = <TableChangedType>params[1] /* 1=TableChangedType */
        if ((changed_type & TableChangedType.Closed) !== 0) {
          me.OnTableClosedChanged();
        } else {
          // todo momentan die daten aktuell halten, und später effezienter modifizieren.
          // todo Idee ist das die Methoden selbst, wie Order() ein GetTable() ausführen, wenn eine Antwort erwartet wird
          // todo wenn differenzen abgeholt werden, kann wichtiges nicht abgerufen werden, weil YAS nicht immer ein Event abfeuert,
          // todo wenn der Client selbst etwas ändert, smarte lösung muss her, sonst erstmal immer vollen tisch abholen
          switch (changed_type) {
            //case TableChangedType.Customer:
            //  me.GetTable(TableData.Customers);
            //  break;
            //case TableChangedType.Items:
            //  me.GetTable(TableData.OrderdItems);
            //  break;
            //case TableChangedType.Payment:
            //  me.GetTable(TableData.PayStatus);
            //  break;
            //case TableChangedType.All:
            default:
              await me.GetTable(TableData.All);
              break;
          }
          // erst aufrufen, wenn GetTable erfolgreich war
          //! todo am besten auch den abgerufenen Tisch versenden, so muss es nicht seperat ermittelt werden
          me._onTableChanged.next(changed_type); // todo aufrufen wenn GetTable die Table verändert
        }
        break;
      default:
        me._coreLogService.error("InHouseOrderService.OnTableChanged", "Unknown Version", params);
        break;
    }
  }

  private _onTableClosed: Subject<{ tableData: ITableQRCode, groupName: string, groupCode: string, placeNo: number, userNickname: string, userToken: string, table: Table }> = new Subject();
  /** Informiert beim Schließen vom Tisch */
  public get ObserveOnTableClosedChanged(): Observable<{ tableData: ITableQRCode, groupName: string, groupCode: string, placeNo: number, userNickname: string, userToken: string, table: Table }> {
    return this._onTableClosed;
  }
  private OnTableClosedChanged(): void {
    const me = this;
    const data = me._currentData;
    const table = me._table;
    try {
      me.CleanupCacheData();
      me.Disconnect();
      // TODO wenn Table Close nicht erwartet wurde, wie beim Bezahlen
      if (!me.suppressNextTableClosedWarning) {
        me.OpenWarningTableClosed();
      }
      me.suppressNextTableClosedWarning = false;
    } catch (error) {
      me._coreLogService.error("InHouseOrderService.OnTableClosedChanged", "catch", error);
    }
    me._onTableClosed.next({ tableData: data.tableData, groupName: data.groupName, groupCode: data.groupCode, placeNo: data.placeNo, userNickname: data.userNickname, userToken: data.userToken, table: table });
  }

  private _onPaymentSelectAborted: Subject<void> = new Subject();
  /** Artikel Zahlungs Auswahl wurde abgebrochen */
  public get ObserveOnPaymentSelectAborted(): Observable<void> {
    return this._onPaymentSelectAborted;
  }
  private OnPaymentSelectAborted(...params: any[]): void {
    const me = this;
    // todo nur zum testen
    me._coreLogService.info("InHouseOrderService.OnPaymentSelectAborted", "triggerd");
    me._onPaymentSelectAborted.next();
  }

  private _onNotification: Subject<{ type: MessageType, message: string }> = new Subject();
  /** Eingehende Nachricht vom POS */
  public get ObserveOnNotification(): Observable<{ type: MessageType, message: string }> {
    return this._onNotification;
  }
  private OnNotification(...params: any[]): void {
    const me = this;
    switch (params[0] /* 0=Version */) {
      case 1:
        // todo nur zum testen
        me._coreLogService.info("InHouseOrderService.OnNotification", "got notification", params);
        me._onNotification.next({ type: params[1], message: params[2] }); /* 1=MessageType, 2=Message */
        break;
      default:
        me._coreLogService.error("InHouseOrderService.OnNotification", "Unknown Version", params);
        break;
    }
  }

  /** Informiert den YourApp Client, dass er dabei ist die Verbindungen zu verlieren (z.B. beim Abschalten des IIS).
   * Auch möglich wenn z.B. der Standort von der Teilnahme am InHouseOrder ausgeschloßen wird.
   * YourApp Client sollte die Verbindung daraufhin trennen und nach einem kurzem Delay kann er es erneut probieren. */
  private OnServerIsDisconnecting(...params: any[]): void {
    const me = this;
    // todo need disconect und nach delay ein reconnect (muss es überhaupt public?)
    me._coreLogService.error("InHouseOrderService.OnServerIsDisconnecting", "todo need disconect und nach delay ein reconnect (muss es überhaupt public?)", params);
    me.Disconnect().then(() => {
      setTimeout(() => { me.Reconnect(me._suspendedConnection); }, 3000);
    }).catch((error) => {
      me._coreLogService.error("InHouseOrderService.OnServerIsDisconnecting", "Disconnect.catch", error);
      setTimeout(() => { me.Reconnect(me._suspendedConnection); }, 3000);
    })
  }

  //#endregion

  //#region Server Funktionen

  /**
   * Ermittelt vom Server zur Gruppenbestellung die Information aus dem GruppenCode
   * @param group_code der GruppenCode der abgefragt wird
   */
  private GetGroupcodeInfo(group_code: string): Promise<GroupcodeInfo> {
    const me = this;
    return new Promise<GroupcodeInfo>((resolve, reject) => {
      try {
        const RequestData = new Groupcode();
        RequestData.code = group_code;
        const FunctionName = "webshop/GetGroupcodeInfo";
        const SyncDataModelConstructor = GroupcodeInfo;
        me._objObsInjectHelper.yourAppServer.Api.RequestService(SyncDataModelConstructor, FunctionName, RequestData)
          .then((response) => {
            if (response.OK) {
              me._coreLogService.debug("InHouseOrderService.GetGroupcodeInfo", "RequestService (response OK)", response);
              resolve(response.Data);
            } else {
              me._coreLogService.error("InHouseOrderService.GetGroupcodeInfo", "RequestService (response not OK)", response);
              reject(response.HttpResponse.codeText);
            }
          })
          .catch((error) => { me._coreLogService.error("InHouseOrderService.GetGroupcodeInfo", "RequestService", error); reject(); });
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.GetGroupcodeInfo", "try catch", error);
        reject();
      }
    });
  }

  /** ermitllung  */
  public GetTableGroupInfo(location: number, table_no: string): Promise<TableGroupInfo> {
    const me = this;
    return new Promise<TableGroupInfo>((resolve, reject) => {
      try {
        const RequestData = new TableGroupRequest();
        RequestData.location = location;
        RequestData.table_no = table_no;
        const FunctionName = "webshop/GetTableGroupInfo";
        const SyncDataModelConstructor = TableGroupInfo;
        me._objObsInjectHelper.yourAppServer.Api.RequestService(SyncDataModelConstructor, FunctionName, RequestData)
          .then((response) => {
            if (response.OK) {
              me._coreLogService.debug("InHouseOrderService.GetTableGroupInfo", "RequestService (response OK)", response);
              // secure if no group_names exists
              response.Data.group_names = response.Data.group_names ? response.Data.group_names : [];
              resolve(response.Data);
            } else {
              me._coreLogService.error("InHouseOrderService.GetTableGroupInfo", "RequestService (response not OK)", response);
              reject(response.HttpResponse.codeText);
            }
          })
          .catch((error) => { me._coreLogService.error("InHouseOrderService.GetTableGroupInfo", "RequestService", error); reject(); });
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.GetTableGroupInfo", "try catch", error);
        reject();
      }
    });
  }

  private debugSignalRCommunication: boolean = true; // todo nur debug

  /** Ermittelt den Status bei der Connection. z.B. Ob ein POS die Anfragen verarbeitet. */
  public async GetStatus(): Promise<res_GetStatus> {
    const me = this;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    const response = await socket.Send<res_GetStatus>(CALL_GET_STATUS);
    if (me.debugSignalRCommunication) // todo nur debug
      me._coreLogService.debug("Send", CALL_GET_STATUS + " Response", response); // todo nur debug
    return response;
  }

  /** Fragt vom Server 3 vorschläge für Gruppennamen. (wenn sie nicht ausreichen muss Gast sich einen Namen ausdenken) */
  public async RecommendGroupNames(): Promise<string[]> {
    const me = this;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    const response = await socket.Send<res_RecommendGroupNames>(CALL_RECOMMEND_GROUPNAMES);
    if (me.debugSignalRCommunication) // todo nur debug
      me._coreLogService.debug("Send", CALL_RECOMMEND_GROUPNAMES + " Response", response); // todo nur debug
    return response.group_names;
  }

  /** RecommendGroupNames reserviert die Namen auch, darum müssen sie wieder freigegeben werden, wenn nicht mehr genutzt. GetPlaceNo kann es auch. */
  public async ReleaseGroupNames(location: number, group_names: string[]): Promise<boolean> {
    const me = this;
    let success = false;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    if (socket.Status == ConnectionState.Connected) {
      const param: req_ReleaseGroupNames = { group_names };
      const response = await socket.Send<res_ReleaseGroupNames>(CALL_RELEASE_GROUPNAMES, param);
      if (me.debugSignalRCommunication) // todo nur debug
        me._coreLogService.debug("Send", CALL_RELEASE_GROUPNAMES + " Response", response);
      success = response.success;
    } else {
      try {
        const RequestData = new ReleaseGroupNamesRequest();
        RequestData.location = location;
        RequestData.names = group_names;
        const FunctionName = "webshop/ReleaseGroupNames";
        const SyncDataModelConstructor = ReleaseGroupNames;
        const response = await me._objObsInjectHelper.yourAppServer.Api.RequestService(SyncDataModelConstructor, FunctionName, RequestData)
        if (response.OK) {
          me._coreLogService.debug("InHouseOrderService.ReleaseGroupNames", "RequestService (response OK)", response);
          success = response.Data.success;
        } else {
          me._coreLogService.error("InHouseOrderService.ReleaseGroupNames", "RequestService (response not OK)", response);
        }
      } catch (error) {
        me._coreLogService.error("InHouseOrderService.ReleaseGroupNames", "try catch", error);
      }
    }
    return success;
  }

  /** Setzt einen User an einen Platz, bzw. kann den Alten Sitzplatz bestätigen */
  private async _GetPlace(param: req_GetPlace): Promise<res_GetPlace> {
    const me = this;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    const response = await socket.Send<res_GetPlace>(CALL_GET_PLACE, param);
    if (me.debugSignalRCommunication) // todo nur debug
      me._coreLogService.debug("Send", CALL_GET_PLACE + " Response", response);
    return response;
  }

  /** Aktualisiert die Customer Daten. Es darf nur nach GetPlace verwendet werden und res_SetCustomer muss req_GetPlace entsprechen. */
  public async UpdateCustomer(param: req_UpdateCustomer): Promise<res_UpdateCustomer> {
    const me = this;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    const response = await socket.Send<res_UpdateCustomer>(CALL_UPDATE_CUSTOMER, param);
    if (me.debugSignalRCommunication) // todo nur debug
      me._coreLogService.debug("Send", CALL_UPDATE_CUSTOMER + " Response", response);
    return response;
  }

  /** Wird Aufgerufen, um den aktuellen Tisch abzurufen (auch Warenkob und GruppenWarenkorb möglich, je nach TableData)
   * Achtung: es werden nur Daten gefüllt, die mit TableData abgefragt wurden, sie dürfen auch nur ausgewertet werden.
   * Denn nicht angeforderte Werte können Standard Werte enthalten.
   */
  private async _GetTable(table_data: TableData): Promise<res_GetTable> {
    const me = this;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    const response = await socket.Send<res_GetTable>(CALL_GET_TABLE, table_data);
    if (response.pos_table) {
      response.pos_table = _renameFull_POSTable(response.pos_table);
    } if (response.yas_table) {
      response.yas_table = _renameFull_YASTable(response.yas_table);
    }
    if (me.debugSignalRCommunication) // todo nur debug
      me._coreLogService.info("Send", CALL_GET_TABLE + " Response", response);
    return response;
  }

  /** Wird Aufgerufen, um Artikel im Warenkorb zu verändern */
  public async ChangeBasket(param: req_ChangeBasket): Promise<res_ChangeBasket> {
    const me = this;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    const response = await socket.Send<res_ChangeBasket>(CALL_CHANGE_BASKET, param);
    if (me.debugSignalRCommunication) // todo nur debug
      me._coreLogService.info("Send", CALL_CHANGE_BASKET + " Response", response);
    return response;
  }

  /** Überträgt die Artikel aus dem UserBasket in den GroupBasket */
  public async MoveToGroupBasket(): Promise<res_MoveToGroupBasket> {
    const me = this;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    const response = await socket.Send<res_MoveToGroupBasket>(CALL_MOVE_TO_GROUP_BASKET);
    if (me.debugSignalRCommunication) // todo nur debug
      me._coreLogService.info("Send", CALL_MOVE_TO_GROUP_BASKET + " Response", response);
    return response;
  }

  /** Wird Aufgerufen, um Artikel im Warenkorb zu verändern */
  public async ChangeGroupBasket(param: req_ChangeGroupBasket): Promise<res_ChangeGroupBasket> {
    const me = this;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    const response = await socket.Send<res_ChangeGroupBasket>(CALL_CHANGE_GROUP_BASKET, param);
    if (me.debugSignalRCommunication) // todo nur debug
      me._coreLogService.info("Send", CALL_CHANGE_GROUP_BASKET + " Response", response);
    return response;
  }

  public async GetVapidPublicKey(): Promise<string> {
    const me = this;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    const response = await socket.Send<res_VapidPublicKey>(CALL_GET_VAPID_PUBLIC_KEY);
    if (me.debugSignalRCommunication) // todo nur debug
      me._coreLogService.info("Send", CALL_GET_VAPID_PUBLIC_KEY + " Response", response);
    return response.key;
  }

  /** Wird Aufgerufen, um die Subscription ans Benachrichtigungssystem zu regestrieren */
  private async RegisterNotification(param: req_RegisterNotification): Promise<res_RegisterNotification> {
    const me = this;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    const response = await socket.Send<res_RegisterNotification>(CALL_REGISTER_NOTIFICATION, param);
    if (me.debugSignalRCommunication) // todo nur debug
      me._coreLogService.info("Send", CALL_REGISTER_NOTIFICATION + " Response", response);
    return response;
  }

  /** Wird Aufgerufen, um die Info zur regestrierten Notification abzufragen */
  public async GetNotificationInfo(): Promise<string> {
    const me = this;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    const response = await socket.Send<res_GetNotificationInfo>(CALL_GET_NOTIFICATION_INFO);
    if (me.debugSignalRCommunication) // todo nur debug
      me._coreLogService.info("Send", CALL_GET_NOTIFICATION_INFO + " Response", response);
    return response.info;
  }

  /** Wird Aufgerufen, Artikel über das POS Bestellt werden */
  public async Order(param: req_Order): Promise<res_Order> {
    const me = this;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    const response = await socket.Send<res_Order>(CALL_ORDER, param);
    if (me.debugSignalRCommunication) // todo nur debug
      me._coreLogService.info("Send", CALL_ORDER + " Response", response);
    return response;
  }

  /** Wird Aufgerufen, Wenn der User seine Artikel als Bemerkt markieren möchte */
  public async ItemsNoticed(item_ids: number[]): Promise<boolean> {
    const me = this;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    const param: req_ItemsNoticed = {
      items: item_ids
    }
    const response = await socket.Send<res_ItemsNoticed>(CALL_ITEMS_NOTICED, param);
    if (me.debugSignalRCommunication) // todo nur debug
      me._coreLogService.info("Send", CALL_ITEMS_NOTICED + " Response", response);
    return response.status == ItemsNoticed_Status.Okay;
  }

  /** Wird Aufgerufen, um die Artikel Zahlungs Auswahl zu beginnen, Bei abbruch muss AbortPaymentSelect aufegrufen werden. */
  public async StartPaymentSelect(): Promise<res_StartPaymentSelect> {
    const me = this;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    const response = await socket.Send<res_StartPaymentSelect>(CALL_START_PAYMENT_SELECT);
    if (me.debugSignalRCommunication) // todo nur debug
      me._coreLogService.info("Send", CALL_START_PAYMENT_SELECT + " Response", response);
    return response;
  }

  /** Wird Aufgerufen, um die Artikel Zahlungs Auswahl zu verändern */
  public async ChangePaymentSelect(param: req_ChangePaymentSelect): Promise<res_ChangePaymentSelect> {
    const me = this;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    const response = await socket.Send<res_ChangePaymentSelect>(CALL_CHANGE_PAYMENT_SELECT, param);
    if (me.debugSignalRCommunication) // todo nur debug
      me._coreLogService.info("Send", CALL_CHANGE_PAYMENT_SELECT + " Response", response);
    return response;
  }

  /** Wird Aufgerufen, um die Artikel Zahlungs Auswahl zu abzubrechen.
   * Soll nicht aufgerufen werden, wenn eine Zahlung durchgeführt werden. */
  public async AbortPaymentSelect(): Promise<res_AbortPaymentSelect> {
    const me = this;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    const response = await socket.Send<res_AbortPaymentSelect>(CALL_ABORT_PAYMENT_SELECT);
    if (me.debugSignalRCommunication) // todo nur debug
      me._coreLogService.info("Send", CALL_ABORT_PAYMENT_SELECT + " Response", response);
    return response;
  }

  /** Wird Aufgerufen, um ein ServiceRuf am POS auszulösen */
  public async ServiceCall(param: req_ServiceCall): Promise<res_ServiceCall> {
    const me = this;
    const socket = me._objObsInjectHelper.yourAppServer.Socket;
    const response = await socket.Send<res_ServiceCall>(CALL_SERVICE_CALL, param);
    if (me.debugSignalRCommunication) // todo nur debug
      me._coreLogService.info("Send", CALL_SERVICE_CALL + " Response", response);
    return response;
  }

  //#endregion

}
